import { render, staticRenderFns } from "./choose.vue?vue&type=template&id=6f188141&scoped=true"
import script from "./choose.vue?vue&type=script&lang=js"
export * from "./choose.vue?vue&type=script&lang=js"
import style0 from "./choose.vue?vue&type=style&index=0&id=6f188141&prod&lang=scss&scoped=true"
import style1 from "./choose.vue?vue&type=style&index=1&id=6f188141&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f188141",
  null
  
)

export default component.exports